/* swt-header-extras.js · SWT Header v2 modules: announcement bar (v2.8
   crossfade + arrows + social magnet) and deal countdown
   (America/Toronto), search (predictive unless Rebuy
   Smart Search is on, sold-out products last), Rebuy cart flyout and
   live cart count. Loaded before swt-header.js, which runs them. */
(function () {
  'use strict';
  var mods = window.SWTHeaderModules = window.SWTHeaderModules || [];

  /* ---------- announcement: crossfade rotation, arrows, countdown, social magnet (v2.8) ----------
     Autoplay every data-rotate seconds (loops). Pauses on mouse hover,
     keyboard focus and a hidden tab; stops for the page view after an arrow
     click. One live message = no arrows, no autoplay. Arrow changes are read
     out (polite live region); autoplay changes are not. Countdowns tick while
     hidden and still hide before start / after end; a message that turns
     off never shows as a blank slide. Theme editor: selecting a message
     block shows it. Reduced motion: instant swap, no magnet. */
  mods.push(function (ctx) {
    var section = ctx.section, sig = ctx.sig, doc = ctx.doc;
    var topbar = section.querySelector('[data-swt-topbar]');

    section.querySelectorAll('[data-swt-locale]').forEach(function (sel) {
      sel.addEventListener('change', function () { if (this.form) this.form.submit(); }, sig);
    });

    if (!topbar) return;

    var tzFmt = null;
    try {
      tzFmt = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Toronto', hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
    } catch (err) { tzFmt = null; }

    function zonedToUtc(y, mo, d, h, mi, s) {
      var guess = Date.UTC(y, mo - 1, d, h, mi, s);
      if (!tzFmt) return guess;
      var p = {};
      tzFmt.formatToParts(new Date(guess)).forEach(function (part) { p[part.type] = part.value; });
      var asUtc = Date.UTC(+p.year, +p.month - 1, +p.day, (+p.hour) % 24, +p.minute, +p.second);
      return guess - (asUtc - guess);
    }

    function parseZoned(str) {
      if (!str) return null;
      var m = String(str).trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?)?$/);
      if (!m) return null;
      return zonedToUtc(+m[1], +m[2], +m[3], m[4] ? +m[4] : 0, m[5] ? +m[5] : 0, m[6] ? +m[6] : 0);
    }

    function pad(n) { return (n < 10 ? '0' : '') + n; }

    /* ----- countdown ----- */
    var countdowns = [];
    topbar.querySelectorAll('[data-swt-countdown]').forEach(function (el) {
      var end = parseZoned(el.getAttribute('data-end'));
      if (end === null) { el.classList.add('is-off'); return; }
      var u = {};
      el.querySelectorAll('[data-cd-unit]').forEach(function (n) { u[n.getAttribute('data-cd-unit')] = n; });
      if (el.getAttribute('data-seconds') !== 'true' && u.s) u.s.classList.add('is-hidden');
      countdowns.push({
        el: el, start: parseZoned(el.getAttribute('data-start')), end: end, u: u,
        sr: el.querySelector('[data-cd-sr]'), expiryMsg: el.getAttribute('data-expiry') === 'message', done: false
      });
    });

    function tick() {
      var now = Date.now(), changed = false;
      countdowns.forEach(function (c) {
        if (c.done) return;
        if (c.start !== null && now < c.start) {
          if (!c.el.classList.contains('is-off')) { c.el.classList.add('is-off'); changed = true; }
          return;
        }
        var diff = c.end - now;
        if (diff <= 0) {
          c.done = true;
          if (c.expiryMsg) { c.el.classList.add('is-expired'); c.el.classList.remove('is-off'); }
          else c.el.classList.add('is-off');
          changed = true;
          return;
        }
        if (c.el.classList.contains('is-off')) { c.el.classList.remove('is-off'); changed = true; }
        var d = Math.floor(diff / 86400000), h = Math.floor(diff / 3600000) % 24;
        var m = Math.floor(diff / 60000) % 60, s = Math.floor(diff / 1000) % 60;
        if (c.u.d) { c.u.d.classList.toggle('is-hidden', d === 0); c.u.d.firstChild.textContent = pad(d); }
        if (c.u.h) c.u.h.firstChild.textContent = pad(h);
        if (c.u.m) c.u.m.firstChild.textContent = pad(m);
        if (c.u.s) c.u.s.firstChild.textContent = pad(s);
        if (c.sr && (s === 0 || !c.sr.textContent)) c.sr.textContent = (d ? d + ' days ' : '') + h + ' hours ' + m + ' minutes left';
      });
      return changed;
    }

    /* ----- rotation ----- */
    var DUR = 450;
    var lessMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var every = Math.max(3, parseFloat(topbar.getAttribute('data-rotate')) || 7) * 1000;
    var say = topbar.querySelector('[data-swt-ann-say]');
    var cur = null, autoT = 0, stopped = false;
    var hold = { hover: false, focus: false, tab: doc.hidden, editor: false };
    var leaveT = [];

    function liveMsgs() {
      return Array.prototype.filter.call(topbar.querySelectorAll('.swt-topbar__msg'), function (m) {
        return !m.classList.contains('is-off');
      });
    }

    function sayText(el) {
      if (!el.hasAttribute('data-swt-countdown')) return el.textContent.replace(/\s+/g, ' ').trim();
      var q = function (s) { var n = el.querySelector(s); return n ? n.textContent.trim() : ''; };
      if (el.classList.contains('is-expired')) return q('.swt-cd__text') + '. ' + q('.swt-cd__expired');
      return (q('.swt-cd__text') + '. ' + q('.swt-cd__label') + ' ' + q('[data-cd-sr]')).trim();
    }

    /* how: 'jump' = no animation, 'fade' = crossfade, 'say' = crossfade + read out */
    function show(el, how) {
      if (!el || el === cur) return;
      var old = cur;
      var instant = how === 'jump' || lessMotion.matches;
      cur = el;
      if (instant) topbar.classList.add('is-instant');
      if (old) { old.classList.remove('is-active'); old.classList.add('is-leaving'); }
      el.classList.remove('is-leaving');
      el.classList.add('is-active');
      if (instant) {
        void topbar.offsetWidth;
        topbar.classList.remove('is-instant');
        if (old) old.classList.remove('is-leaving');
      } else if (old) {
        leaveT.push(setTimeout(function () {
          leaveT.shift();
          if (old !== cur) old.classList.remove('is-leaving');
        }, DUR + 60));
      }
      if (how === 'say' && say) say.textContent = sayText(el);
    }

    function step(dir, how) {
      var list = liveMsgs();
      if (list.length < 2) return;
      var i = list.indexOf(cur);
      var n = i < 0 ? (dir > 0 ? 0 : list.length - 1) : (i + dir + list.length) % list.length;
      show(list[n], how);
    }

    function schedule() {
      clearTimeout(autoT);
      if (stopped || hold.hover || hold.focus || hold.tab || hold.editor || liveMsgs().length < 2) return;
      autoT = setTimeout(function () { step(1, 'fade'); schedule(); }, every);
    }

    /* after load and whenever a countdown starts / ends */
    function sync() {
      var list = liveMsgs();
      topbar.classList.toggle('is-empty', list.length === 0);
      topbar.classList.toggle('has-many', list.length > 1);
      if (cur && list.indexOf(cur) < 0) { cur.classList.remove('is-active', 'is-leaving'); cur = null; }
      if (!cur && list.length) show(list[0], 'jump');
    }

    function arrow(dir) {
      stopped = true;
      clearTimeout(autoT);
      step(dir, 'say');
    }
    var prevB = topbar.querySelector('[data-swt-ann-prev]');
    var nextB = topbar.querySelector('[data-swt-ann-next]');
    if (prevB) prevB.addEventListener('click', function () { arrow(-1); }, sig);
    if (nextB) nextB.addEventListener('click', function () { arrow(1); }, sig);

    topbar.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'touch') return;
      hold.hover = true; schedule();
    }, sig);
    topbar.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'touch') return;
      hold.hover = false; schedule();
    }, sig);
    topbar.addEventListener('focusin', function (e) {
      var kb = true;
      try { kb = e.target.matches(':focus-visible'); } catch (err) { kb = true; }
      hold.focus = kb; schedule();
    }, sig);
    topbar.addEventListener('focusout', function (e) {
      if (e.relatedTarget && topbar.contains(e.relatedTarget)) return;
      hold.focus = false; schedule();
    }, sig);
    doc.addEventListener('visibilitychange', function () { hold.tab = doc.hidden; schedule(); }, sig);

    /* theme editor: selecting a message block shows it and holds it */
    doc.addEventListener('shopify:block:select', function (e) {
      var el = e.target && e.target.closest ? e.target.closest('.swt-topbar__msg') : null;
      if (!el || !topbar.contains(el)) return;
      hold.editor = true;
      clearTimeout(autoT);
      if (!el.classList.contains('is-off')) show(el, 'fade');
    }, sig);
    doc.addEventListener('shopify:block:deselect', function () {
      if (!hold.editor) return;
      hold.editor = false; schedule();
    }, sig);

    tick();
    sync();
    schedule();
    if (countdowns.length) {
      ctx.intervals.push(setInterval(function () { if (tick()) { sync(); schedule(); } }, 1000));
    }

    /* ----- social icons: magnetic pull (real mouse only, motion allowed) ----- */
    var anyHover = window.matchMedia('(any-hover: hover)');
    var mags = topbar.querySelectorAll('[data-swt-magnet]');
    var magAc = null;
    function bindMagnet() {
      if (magAc) { magAc.abort(); magAc = null; }
      mags.forEach(function (a) {
        a.classList.remove('is-pull');
        if (a.firstElementChild) a.firstElementChild.style.transform = '';
      });
      if (!mags.length || !anyHover.matches || lessMotion.matches) return;
      magAc = new AbortController();
      var ms = { signal: magAc.signal };
      mags.forEach(function (a) {
        var icon = a.firstElementChild, raf = 0, mx = 0, my = 0;
        if (!icon) return;
        a.addEventListener('pointermove', function (e) {
          if (e.pointerType !== 'mouse') return;
          mx = e.clientX; my = e.clientY;
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = 0;
            var r = a.getBoundingClientRect();
            if (!r.width || !r.height) return;
            var x = Math.max(-5, Math.min(5, (mx - r.left - r.width / 2) / r.width * 10));
            var y = Math.max(-5, Math.min(5, (my - r.top - r.height / 2) / r.height * 10));
            a.classList.add('is-pull');
            icon.style.transform = 'translate3d(' + x.toFixed(2) + 'px, ' + y.toFixed(2) + 'px, 0)';
          });
        }, ms);
        a.addEventListener('pointerleave', function () {
          if (raf) { cancelAnimationFrame(raf); raf = 0; }
          a.classList.remove('is-pull');
          icon.style.transform = '';
        }, ms);
      });
    }
    bindMagnet();
    if (mags.length) {
      anyHover.addEventListener('change', bindMagnet, sig);
      lessMotion.addEventListener('change', bindMagnet, sig);
    }

    return function () {
      clearTimeout(autoT);
      leaveT.forEach(clearTimeout);
      if (magAc) magAc.abort();
    };
  });

  /* ---------- search ---------- */
  mods.push(function (ctx) {
    var root = ctx.root, doc = ctx.doc, sig = ctx.sig;
    var wrap = root.querySelector('[data-swt-search]');
    var toggle = root.querySelector('[data-swt-search-toggle]');
    var input = root.querySelector('[data-swt-search-input]');
    var results = root.querySelector('[data-swt-search-results]');
    var predictiveUrl = root.getAttribute('data-predictive-url') || '/search/suggest';
    var searchUrl = root.getAttribute('data-search-url') || '/search';
    var useRebuy = root.getAttribute('data-rebuy-search') === 'true';
    var t = 0;

    function open() {
      root.classList.add('is-search-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (input) input.focus();
    }
    function close() {
      root.classList.remove('is-search-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (results) results.innerHTML = '';
    }
    if (toggle) toggle.addEventListener('click', function () {
      if (root.classList.contains('is-search-open')) close(); else open();
    }, sig);
    root.querySelectorAll('[data-swt-search-close]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (input && input.value) {
          input.value = '';
          if (input.form) input.form.classList.remove('has-value');
          if (results) results.innerHTML = '';
          input.focus();
        } else close();
      }, sig);
    });
    doc.addEventListener('click', function (e) {
      if (wrap && !wrap.contains(e.target) && !(toggle && toggle.contains(e.target))) {
        if (results) results.innerHTML = '';
        root.classList.remove('is-search-open');
      }
    }, sig);
    doc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !e.swtHandled) close();
    }, sig);

    function esc(s) {
      return (s || '').replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    if (input) input.addEventListener('input', function () {
      if (input.form) input.form.classList.toggle('has-value', input.value.length > 0);
      if (useRebuy || !results) return;
      var q = input.value.trim();
      clearTimeout(t);
      if (q.length < 2) { results.innerHTML = ''; return; }
      t = setTimeout(function () {
        var url = predictiveUrl + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var rr = (data && data.resources && data.resources.results) || {};
            var html = '';
            (rr.products || []).forEach(function (p) {
              var img = p.image || (p.featured_image && p.featured_image.url) || '';
              html += '<a class="swt-sresult" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '<span class="swt-sresult__t">' + esc(p.title) + '</span></a>';
            });
            (rr.collections || []).forEach(function (c) {
              html += '<a class="swt-sresult" href="' + c.url + '"><span class="swt-sresult__t">' + esc(c.title) + '</span></a>';
            });
            html += '<a class="swt-sresult swt-sresult--all" href="' + searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bunavailable_products%5D=last">Search for &ldquo;' + esc(q) + '&rdquo;</a>';
            results.innerHTML = html;
          })
          .catch(function () { results.innerHTML = ''; });
      }, 220);
    }, sig);

    return function () { clearTimeout(t); };
  });

  /* ---------- cart: Rebuy Smart Cart flyout + live count ---------- */
  mods.push(function (ctx) {
    var doc = ctx.doc, sig = ctx.sig;
    var cartUrl = ctx.root.getAttribute('data-cart-url') || '/cart';
    doc.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a[href="' + cartUrl + '"]');
      if (!link) return;
      var R = window.Rebuy;
      if (R && R.SmartCart && typeof R.SmartCart.show === 'function') {
        e.preventDefault();
        e.stopPropagation();
        ctx.closeDrawer();
        R.SmartCart.show();
      }
    }, { capture: true, signal: sig.signal });

    function refresh() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          doc.querySelectorAll('[data-swt-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.classList.toggle('is-empty', cart.item_count === 0);
          });
        })
        .catch(function () {});
    }
    doc.addEventListener('swt:cart:added', refresh, sig);
    doc.addEventListener('rebuy:cart.change', refresh, sig);
  });
})();